<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bz1t38/tc-custom/9781504099882.jpg?1728726136596" alt="This image is the cover for the book Other Bridget"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Other Bridget
      </h1>
      <p class="bookDescription body article font2">
        <b>“A feisty book-loving heroine, two hot heroes, and side plots about characters you care about . . . this lovely romance will keep you turning pages.” —Paige Toon, bestselling author of <i>Seven Summers</i></b><br/><br/> Librarian Bridget Jones, named after the famous fictional heroine, was raised on a remote farm with only her mother’s romance novels for company.<br/><br/> Now, living alone in the city, Bridget is a hopeless bookaholic and believes that anyone who doesn’t like reading just hasn’t met the right book yet. If only fixing her love life was that simple.<br/><br/> After handsome Italian barista Fabio catches her eye, Bridget prays she won’t ruin things. But when her cranky neighbor Sully insists on making life tricky, she is faced with a new obstacle. Why is he going to so much trouble to drive her ’round the bend?<br/><br/> With the help of a colorful cast of friends, Bridget decides to put both men to the test. But will mixing romance and fiction lead to her happily ever after?<br/><br/> “Entertaining and charming, Rachael Johns is arguably the best romantic writer in Australia.” —<i>The Australian</i><br/><br/> “Pure sunshine for the soul. I just loved it!” —Tess Woods, author of <i>The Venice Hotel</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachael Johns
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15837a78